<div>
  <div class="va-banner">
    <div class="va-banner-img"><img src="/assets/images/virtual-account-banner.png"
                                    alt="Virtual account"/></div>
  </div>

  <div class="container">
    <div class="media-banner-box">
      <div class="mediabenertop" style="text-transform: uppercase">
        <span>{{ spotlight$.published_at | date: 'd MMMM y':'GMT' }}</span></div>
      <h3>{{ spotlight$.title || spotlight$.route }}</h3>
      <p>{{ spotlight$.excerpt }}</p>
      <p>
        <a [routerLink]="[spotlight$.route]" class="mediabtns mb-5">Read More <i class="fa fa-long-arrow-right btncions"
                                                                                 aria-hidden="true"></i>
        </a>
      </p>
    </div>
  </div>

  <div class="media-bottombg">
    <div class="container">
      <div class="media-relasttop">
        <h4>Press Releases</h4>
      </div>
      <div style="clear: both;"></div>
      <section class="panel" data-color="indigo">
        <div class="row">

          <article *ngFor="let media of media$ | async | slice: 1" class="col-lg-4 col-md-6">
            <a [routerLink]="[media.route]" class="mediaboxshow">
              <div class="realesimgdiv"><img src="{{ media.thumbnail || '/assets/images/matchmove-logo-vertical.png' }}" alt="{{ media.title || media.route }}"
                                             border="0" class="realesimgdiv"/></div>
            </a>
            <div class="medeaboxinss">
              <h3 style="text-transform: uppercase">{{ media.published_at | date: 'd MMMM y':'GMT' }}</h3>
              <p>{{ media.title || media.route }}</p>
              <a [routerLink]="[media.route]" class="pressreleases">Read More</a>
            </div>
          </article>

        </div>
      </section>

      <p class="mb-0 mt-5"><a href="mailto:marketing@matchmove.com" class="btnstyl1">Media contacts</a></p>
<!--      <div style="clear: both;"></div>-->
<!--      <div class="padinginfo">-->
<!--        <ul>-->
<!--          <li><a href="media" class="pageactives">1</a></li>-->
<!--          <li><a href="media">2</a></li>-->
<!--          <li><a href="media">3</a></li>-->
<!--          <li>-->
<!--            <a href="media">Next <i class="fa fa-angle-double-right arrowshws" aria-hidden="true"></i> </a>-->
<!--          </li>-->
<!--        </ul>-->
<!--      </div>-->
    </div>
  </div>
</div>
